import React from 'react';
import { Button, Form, Input, message, Modal, Rate } from 'antd';
import { RateStarIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { useSendComment } from 'modules/global';

interface IProps {
  ticketId?: string;
  onClose: () => void;
  open: boolean;
}
const { TextArea } = Input;

const RateModal: React.FC<IProps> = ({ ticketId, onClose, open }) => {
  const t = useTranslations();
  //   const { errorType, isLoading } = useFeedbackErrorType(questionId);
  const { mutate, isLoading: isSendLoading } = useSendComment();
  const [form] = Form.useForm();

  const onFinish = (values: { error_id: number; massage: string }) => {
    mutate(
      { ...values, ticket_id: ticketId },
      {
        onSuccess: () => {
          form.resetFields();
          onClose();
          message.success(t('Muvaffaqiyatli_bajarildi'));
        }
      }
    );
  };

  return (
    <Modal
      footer={false}
      open={open}
      centered
      onCancel={onClose}
      width="26rem"
      closeIcon={false}
      styles={{
        content: { padding: '1rem', borderRadius: '0.75rem' }
      }}
      title={<span className="text-lg">{t('Testni_baholash')}</span>}
    >
      <Form form={form} initialValues={{ rating: 5 }} onFinish={onFinish}>
        <Form.Item
          name="rating"
          help={null}
          className="flex items-center justify-center"
          rules={[
            {
              required: true
            }
          ]}
        >
          <Rate character={<RateStarIcon />} />
        </Form.Item>
        <Form.Item
          name="comment"
          help={null}
          rules={[
            {
              required: true
            }
          ]}
          validateStatus={form.getFieldError('comment').length > 0 ? 'error' : undefined}
        >
          <TextArea
            className="!border-transparent !bg-[#f2f3f5] hover:!border-green-500 focus:!border-green-500"
            rows={4}
            placeholder={t('Fikringizni_kiriting')}
            maxLength={200}
          />
        </Form.Item>

        <div className="mt-3 flex items-center gap-2">
          <Button
            onClick={() => onClose()}
            className="w-30 !rounded-lg !border-none !bg-gray-100 !px-3 !py-5 hover:!border-none hover:!text-black"
          >
            {t('ortga')}
          </Button>
          <Button
            loading={isSendLoading}
            htmlType="submit"
            className="!w-full !rounded-lg !border-none !bg-green-500 !px-7 !py-5 !text-white hover:!border-none"
          >
            {t('Yuborish')}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default RateModal;
